/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Spinner from "../components/spinner";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

const ProjectMaster = ({
  addCategory,
  handleNext,
  handleBack,
  projectType,
  setProjectType,
  noExp,
  setNoOfExpension,
  preProCost,
  setPreProjectCost,
  costProject,
  setCostProject,
  promoterCont,
  setPromoterCont,
  loanAmt,
  setLoanAmt,
  noMachine,
  setNoMachine,
  typeMachine,
  setTypeMachine,
  machineFrom,
  setMachineFrom,
  proMachineType,
  setProMachineType,
  dateCom,
  setDateCom,
  loanSanction,
  setLoanSanction,
  loanDisbursed,
  setLoanDisbursed,
  rateInterest,
  setRateInterest,
  loanAcc,
  setLoanAcc,
  bankName,
  setBankName,
  bankBranch,
  setBankBranch,
  managerName,
  setManagerName,
  managerMobile,
  setManagerMobile,
  cgtmseAns,
  setCgtmseAns,
  cgPanNo,
  setCgPanNo,
  cgCharges,
  setCgCharges,
  firstRegistration,
  setFirstRegistration,
  activity,
  setActivity
}) => {
  const location = useLocation();
  const { state } = location;
  const projectId = localStorage.getItem("projectId");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProModalOpen, setIsProModalOpen] = useState(false);
  const [isActivityModal, setIsActivityModal] = useState(false);
  // const client_Id = localStorage.getItem('clientId')

  const [errProjectType, setErrProjectType] = useState("proType");
  const [errNoOfExpension, setErrNoOfExpension] = useState("expension");
  const [errPreProjectCost, setErrPreProjectCost] = useState("preCost");
  const [errPromoterCont, setErrPromoterCont] = useState("promoterCont");
  const [errLoanAmt, setErrLoanAmt] = useState("loanAmt");
  const [errNoMachine, setErrNoMachin] = useState("noMachine");
  const [errTypeMachine, setErrTypeMachine] = useState("typeMachine");
  const [errMachineFrom, setErrMachineFrom] = useState("machineFrom");
  const [errProMachineType, setErrProMachineType] = useState("proMachineType");
  const [errDateCom, setErrDateCom] = useState("dateCom");
  const [errLoanSanction, setErrLoanSanction] = useState("loanSanction");
  const [errLoanDisbursed, setErrLoanDisbursed] = useState("loanDisbursed");
  const [errRateInterest, setErrRateInterest] = useState("rateInt");
  const [errLoanAcc, setErrLoanAcc] = useState("loanAcc");
  const [errBankName, setErrBankName] = useState("bankName");
  const [errBankBranch, setErrBankBranch] = useState("bankBranch");
  const [errManagerName, setErrManagerName] = useState("managerName");
  const [errCgPanNo, setErrCgPanNo] = useState("cgPanNo");
  const [errCgCharges, setErrCgCharges] = useState("cgCharges");
  const [errActivity, setErrActivity] = useState('activity')
  const [inputValue, setInputValue] = useState("");
  const [inputProValue, setInputProValue] = useState("");
  const [inputActivity, setInputActivity] = useState("");
  const [data, setData] = useState([]);
  const [proMachineData, setProMachineData] = useState([]);
  const [activityData, setActiveData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [applyCheck, setApplyCheck] = useState(false);

  const validateForm = () => {
    let valid = false;
    if (projectType === "" || projectType === null) {
      setErrProjectType(projectType);
      valid = true;
    }
    if (projectType === "expansion") {
      if (noExp === "" || noExp === undefined || noExp === null) {
        setErrNoOfExpension(noExp);
        valid = true;
      }
      if (
        preProCost === "" ||
        preProCost === undefined ||
        preProCost === null
      ) {
        setErrPreProjectCost(preProCost);
        valid = true;
      }
    }
    if (
      promoterCont === "" ||
      promoterCont === undefined ||
      promoterCont === null
    ) {
      setErrPromoterCont(promoterCont);
      valid = true;
    }
    if (loanAmt === "" || loanAmt === undefined || loanAmt === null) {
      setErrLoanAmt(loanAmt);
      valid = true;
    }
    if (noMachine === "" || noMachine === undefined || noMachine === null) {
      setErrNoMachin(noMachine);
      valid = true;
    }
    if (typeMachine.length === 0 || typeMachine === undefined) {
      setErrTypeMachine(typeMachine);
      valid = true;
    }
    if (machineFrom === "" || machineFrom === null) {
      setErrMachineFrom(machineFrom);
      valid = true;
    }
    if (proMachineType.length === 0 || proMachineType === null) {
      setErrProMachineType(proMachineType);
      valid = true;
    }
    if (dateCom === "" || dateCom === undefined || dateCom === null) {
      setErrDateCom(dateCom);
      valid = true;
    }
    if (
      loanSanction === "" ||
      loanSanction === undefined ||
      loanSanction === null
    ) {
      setErrLoanSanction(loanSanction);
      valid = true;
    }
    if (
      loanDisbursed === "" ||
      loanDisbursed === undefined ||
      loanDisbursed === null
    ) {
      setErrLoanDisbursed(loanDisbursed);
      valid = true;
    }
    if (
      rateInterest === "" ||
      rateInterest === undefined ||
      rateInterest === null
    ) {
      setErrRateInterest(rateInterest);
      valid = true;
    }
    if (loanAcc === "" || loanAcc === undefined || loanAcc === null) {
      setErrLoanAcc(loanAcc);
      valid = true;
    }
    if (bankName === "" || bankName === null) {
      setErrBankName(bankName);
      valid = true;
    }
    if (bankBranch === "" || bankBranch === null) {
      setErrBankBranch(bankBranch);
      valid = true;
    }
    if (managerName === "" || managerName === null) {
      setErrManagerName(managerName);
      valid = true;
    }
    if (cgtmseAns === "yes") {
      if (cgPanNo === "" || cgPanNo === null) {
        setErrCgPanNo(cgPanNo);
        valid = true;
      }
      if (cgCharges === "" || cgCharges === undefined || cgCharges === null) {
        setErrCgCharges(cgCharges);
        valid = true;
      }
    }
    if (activity.length === 0 || activity === null) {
      setErrActivity(activity);
      valid = true;
    }
    return valid;
  };
  const handleNexts = async () => {
    if (!validateForm()) {
      try {
        setIsLoading(true);
        const client_Id = state?.clientId || localStorage.getItem("clientId");

        const noOfExpension = projectType === "new" ? 0 : noExp;
        const preProjectCost = projectType === "new" ? 0 : preProCost;
        const cgtmsePanNo = cgtmseAns === "no" ? "" : cgPanNo;
        const cgtmseCharges = cgtmseAns === "no" ? 0 : cgCharges;
        const cgtmse = cgtmseAns;
        const projectMachineType = proMachineType?.map((item) => item.value);
        const typemachine = typeMachine?.map((item) => item.value);
        const activityType = activity?.map((item) => item.value);
        const capital = addCategory == 'category_1' ? 30 : addCategory == 'category_2' ? 20 : 10;
        const amount2 = costProject <= 10000000 ? costProject * (capital / 100) : 0;
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/update-project/${
            projectId || state?.projectId
          }`,
          {
            amount2,
            client_Id,
            projectType,
            costProject,
            promoterCont,
            loanAmt,
            noMachine,
            typeMachine: JSON.stringify(typemachine),
            machineFrom,
            proMachineType: JSON.stringify(projectMachineType),
            dateCom,
            loanSanction,
            loanDisbursed,
            rateInterest,
            loanAcc,
            bankName,
            noOfExpension,
            preProjectCost,
            cgtmse,
            bankBranch,
            managerName,
            managerMobile,
            cgtmsePanNo,
            cgtmseCharges,
            firstRegistration,
            activityType: JSON.stringify(activityType)
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("signIn")}`,
            },
          }
        );

        if (response.status === 200) {
          localStorage.setItem("projectId", response.data.result.id);
          handleNext();
        }
      } catch (error) {
        console.error("Error submitting project data:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const formatDateForDisplay = (dateFromDatabase) => {
    const invalidDateValue = "0000-00-00";
    const specialDateValue = "1899-11-29T18:38:50.000Z";

    if (
      dateFromDatabase === invalidDateValue ||
      dateFromDatabase === specialDateValue
    ) {
      return null;
    }

    const dateObject = new Date(dateFromDatabase);

    if (isNaN(dateObject.getTime())) {
      return null;
    }

    dateObject.setDate(dateObject.getDate() - 0);
    dateObject.setHours(18, 30, 0, 0);

    return dateObject;
  };

  const handleData = async () => {
    if (projectId !== null || state?.projectId) {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-project-byId/${
          projectId || state?.projectId
        }`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("signIn")}`,
          },
        }
      );
      const project = response.data.result[0];
      const projectMachine = project?.proMachineType
        ? JSON.parse(project.proMachineType)
        : [];
      const proMachineOptions = projectMachine.map((item) => ({
        label: item,
        value: item,
      }));

      const typeMachine = project?.typeMachine
        ? JSON.parse(project.typeMachine)
        : [];
      const typemachineOptions = typeMachine.map((item) => ({
        label: item,
        value: item,
      }));

      const activityTypes = project?.activityType	? JSON.parse(project.activityType)
      : [];

      const activityTypeOptions = activityTypes.map((item) => ({
        label: item,
        value: item,
      }));

      setProjectType(project?.projectType);
      setNoOfExpension(project?.noOfExpension);
      setPreProjectCost(project?.preProjectCost);
      setCostProject(project?.costProject);
      setPromoterCont(project?.promoterCont);
      setLoanAmt(project?.loanAmt);
      setNoMachine(project?.noMachine);
      setTypeMachine(typemachineOptions);
      setMachineFrom(project?.machineFrom);
      setDateCom(formatDateForDisplay(project?.dateCom));
      setProMachineType(proMachineOptions);
      setLoanSanction(formatDateForDisplay(project?.loanSanction));
      setLoanDisbursed(formatDateForDisplay(project.loanDisbursed));
      setRateInterest(project?.rateInterest);
      setLoanAcc(project?.loanAcc);
      setBankName(project?.bankName);
      setBankBranch(project?.bankBranch);
      setManagerName(project?.managerName);
      setManagerMobile(project?.managerMobile);
      setCgtmseAns(project?.cgtmse);
      setCgCharges(project?.cgtmseCharges);
      setCgPanNo(project?.cgtmsePanNo);
      setFirstRegistration(formatDateForDisplay(project?.firstRegistration))
      setActivity(activityTypeOptions)
    }
  };
  useEffect(()=>{
    setApplyCheck(true);
  }, [firstRegistration]);

  const handleOpenProModal = () => {
    setIsProModalOpen(true);
  };

  const handleCloseProModal = () => {
    setIsProModalOpen(false);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSave = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/create-type-machine`,
        {
          typeMachine: inputValue,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("signIn")}`,
          },
        }
      );

      if (response.status === 201) {
        setIsModalOpen(false);
        handleMachineData();
        setTypeMachine([
          {
            label: response.data.result.typeMachine,
            value: response.data.result.typeMachine,
          },
        ]);
        setErrTypeMachine([
          {
            label: response.data.result.typeMachine,
            value: response.data.result.typeMachine,
          },
        ]);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleProjectSave = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/create-project-machine-type`,
        {
          projectMachineType: inputProValue,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("signIn")}`,
          },
        }
      );

      if (response.status === 201) {
        setIsProModalOpen(false);
        handleProMachineData();
        setProMachineType([
          {
            label: response.data.result.projectMachineType,
            value: response.data.result.projectMachineType,
          },
        ]);
        setErrProMachineType([
          {
            label: response.data.result.projectMachineType,
            value: response.data.result.projectMachineType,
          },
        ]);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleActivity = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/create-activity`,
        {
          typeOfActivity: inputActivity,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("signIn")}`,
          },
        }
      );

      if (response.status === 201) {
        setIsActivityModal(false);
        handleActivityData();
        setActivity([
          {
            label: response.data.result.typeOfActivity,
            value: response.data.result.typeOfActivity,
          },
        ]);
        setErrActivity([
          {
            label: response.data.result.typeOfActivity,
            value: response.data.result.typeOfActivity,
          },
        ]);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const updateCostProject = (promoterCont, loanAmt, projectType) => {
    let totalCost;

    const promoterContNumber = parseFloat(promoterCont) || 0;
    const loanAmtNumber = parseFloat(loanAmt) || 0;

    if (projectType === "new" || projectType === "expansion") {
      totalCost = Math.abs(promoterContNumber + loanAmtNumber);
    }

    if (!isNaN(totalCost)) {
      setCostProject(Number(totalCost.toFixed(2)));
    } else {
      console.error("Invalid totalCost:", totalCost);
    }
  };

  const handleMachineData = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/get-type-machine`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("signIn")}`,
        },
      }
    );
    const options = response.data?.result.map((value) => ({
      label: value.typeMachine,
      value: value.typeMachine,
    }));
    setData(options);
  };

  const handleProMachineData = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/get-project-machine-type`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("signIn")}`,
        },
      }
    );
    const options = response.data?.result.map((value) => ({
      label: value.projectMachineType,
      value: value.projectMachineType,
    }));
    setProMachineData(options);
  };

  const handleActivityData = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/get-activity`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("signIn")}`,
        },
      }
    );
    const options = response.data?.result.map((value) => ({
      label: value.typeOfActivity,
      value: value.typeOfActivity,
    }));
    setActiveData(options);
  };

  useEffect(() => {
    handleData();
    handleMachineData();
    handleProMachineData();
    handleActivityData()
  }, [projectId, state?.projectId]);

  return (
    <div>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="container card card-body">
            <form>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>Type of Project</label>
                  <select
                    className={`custom-select mr-sm-2 ${
                      (errProjectType === "" || errProjectType === null) &&
                      "is-invalid"
                    }`}
                    value={projectType || ""}
                    onChange={(e) => {
                      setProjectType(e.target.value);
                      setErrProjectType(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="expansion">Expansion</option>
                    <option value="new">New</option>
                  </select>
                  {(errProjectType === "" || errProjectType === null) && (
                    <p className="invalid-feedback">
                      Type of Project is required
                    </p>
                  )}
                </div>
              </div>

              {projectType === "expansion" && (
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label>Number of Expensions</label>
                    <input
                      type="number"
                      className={`form-control ${
                        (errNoOfExpension === null ||
                          errNoOfExpension === "" ||
                          errNoOfExpension === undefined) &&
                        "is-invalid"
                      }`}
                      value={noExp || ""}
                      onChange={(e) => {
                        setNoOfExpension(e.target.value);
                        setErrNoOfExpension(e.target.value);
                      }}
                    />
                    {(errNoOfExpension === null ||
                      errNoOfExpension === "" ||
                      errNoOfExpension === undefined) && (
                      <p className="invalid-feedback">
                        Number of Expensions is required
                      </p>
                    )}
                  </div>
                  <div className="form-group col-md-6">
                    <label>Previous Project Cost</label>
                    <input
                      type="number"
                      className={`form-control ${
                        (errPreProjectCost === null ||
                          errPreProjectCost === "" ||
                          errPreProjectCost === undefined) &&
                        "is-invalid"
                      }`}
                      value={preProCost || ""}
                      onChange={(e) => {
                        setPreProjectCost(e.target.value);
                        setErrPreProjectCost(e.target.value);
                      }}
                    />
                    {(errPreProjectCost === null ||
                      errPreProjectCost === "" ||
                      errPreProjectCost === undefined) && (
                      <p className="invalid-feedback">
                        Previous Project Cost is required
                      </p>
                    )}
                  </div>
                </div>
              )}
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>Promoter Contribution</label>
                  <input
                    type="number"
                    className={`form-control ${
                      (errPromoterCont === null ||
                        errPromoterCont === "" ||
                        errPromoterCont === undefined) &&
                      "is-invalid"
                    }`}
                    value={promoterCont || ""}
                    step="0.01"
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setPromoterCont(newValue);
                      setErrPromoterCont(newValue);
                      updateCostProject(newValue, loanAmt, projectType);
                    }}
                  />
                  {(errPromoterCont === null ||
                    errPromoterCont === "" ||
                    errPromoterCont === undefined) && (
                    <p className="invalid-feedback">
                      Promoter Contribution is required
                    </p>
                  )}
                </div>

                <div className="form-group col-md-6">
                  <label>Loan Amount</label>
                  <input
                    type="number"
                    className={`form-control ${
                      (errLoanAmt === null ||
                        errLoanAmt === "" ||
                        errLoanAmt === undefined) &&
                      "is-invalid"
                    }`}
                    value={loanAmt || ""}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setLoanAmt(parseFloat(newValue));
                      setErrLoanAmt(newValue);
                      updateCostProject(promoterCont, newValue, projectType);
                    }}
                  />
                  {(errLoanAmt === null ||
                    errLoanAmt === "" ||
                    errLoanAmt === undefined) && (
                    <p className="invalid-feedback">Loan Amount is required</p>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>Cost of Project</label>
                  <input
                    type="number"
                    className={`form-control`}
                    value={costProject || ""}
                    readOnly
                  />
                </div>

                <div className="form-group col-md-6">
                  <p>CGTMSE</p>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      id="cgtmseYes"
                      value="yes"
                      className="form-check-input"
                      checked={cgtmseAns === "yes"}
                      onChange={(e) => setCgtmseAns(e.target.value)}
                    />
                    <label htmlFor="cgtmseYes" className="form-check-label">
                      Yes
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      id="cgtmseNo"
                      value="no"
                      className="form-check-input"
                      checked={cgtmseAns === "no"}
                      onChange={(e) => setCgtmseAns(e.target.value)}
                    />
                    <label htmlFor="cgtmseNo" className="form-check-label">
                      No
                    </label>
                  </div>
                </div>
              </div>

              {cgtmseAns === "yes" && (
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label>CGTMSE Pan number</label>
                    <input
                      type="text"
                      className={`form-control ${
                        (errCgPanNo === null || errCgPanNo === "") &&
                        "is-invalid"
                      }`}
                      value={cgPanNo || ""}
                      onChange={(e) => {
                        setCgPanNo(e.target.value);
                        setErrCgPanNo(e.target.value);
                      }}
                    />
                    {(errCgPanNo === null ||
                      errCgPanNo === "" ||
                      errCgPanNo === undefined) && (
                      <p className="invalid-feedback">
                        CGTMSE Pan number is required
                      </p>
                    )}
                  </div>
                  <div className="form-group col-md-6">
                    <label>CGTMSE Charges</label>
                    <input
                      type="number"
                      className={`form-control ${
                        (errCgCharges === null ||
                          errCgCharges === "" ||
                          errCgCharges === undefined) &&
                        "is-invalid"
                      }`}
                      value={cgCharges || ""}
                      onChange={(e) => {
                        setCgCharges(e.target.value);
                        setErrCgCharges(e.target.value);
                      }}
                    />
                    {(errCgCharges === null ||
                      errCgCharges === "" ||
                      errCgCharges === undefined) && (
                      <p className="invalid-feedback">
                        CGTMSE Charges is required
                      </p>
                    )}
                  </div>
                </div>
              )}

              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>No of Machine</label>
                  <input
                    type="number"
                    className={`form-control ${
                      (errNoMachine === null ||
                        errNoMachine === "" ||
                        errNoMachine === undefined) &&
                      "is-invalid"
                    }`}
                    value={noMachine || ""}
                    onChange={(e) => {
                      setNoMachine(e.target.value);
                      setErrNoMachin(e.target.value);
                    }}
                  />
                  {(errNoMachine === null ||
                    errNoMachine === "" ||
                    errNoMachine === undefined) && (
                    <p className="invalid-feedback">
                      No of Machine is required
                    </p>
                  )}
                </div>
                <div className="form-group col-md-5">
                  <label>Supplier Machine</label>
                  <Select
                    isMulti
                    className={`${
                      (errTypeMachine.length === 0 || errTypeMachine === "") &&
                      "is-invalid"
                    }`}
                    options={data}
                    value={typeMachine}
                    onChange={(selectedOption) => {
                      setTypeMachine(selectedOption);
                      setErrTypeMachine(selectedOption);
                    }}
                    placeholder="Select"
                  />
                  {(errTypeMachine.length === 0 || errTypeMachine === "") && (
                    <p className="invalid-feedback">
                      Supplier Machine is required
                    </p>
                  )}
                </div>
                <div className="form-group col-md-1">
                  <button
                    type="button"
                    style={{ border: "1px solid gray", marginTop: "29px" }}
                    className="btn btn-outline-secondary col-xs-offset-1"
                    onClick={() => {
                      handleOpenModal();
                    }}
                  >
                    <i className="bi bi-plus-lg"></i>
                  </button>
                </div>
              </div>

              <Modal show={isModalOpen} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Supplier Machine</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Control
                        className={`form-control`}
                        type="text"
                        name="nameOfKey"
                        onChange={(e) => {
                          setInputValue(e.target.value);
                        }}
                      />
                    </Form.Group>
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseModal}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={handleSave}>
                    Save
                  </Button>
                </Modal.Footer>
              </Modal>

              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>Indigenous/Imported</label>
                  <select
                    className={`custom-select mr-sm-2 ${
                      (errMachineFrom === null || errMachineFrom === "") &&
                      "is-invalid"
                    }`}
                    value={machineFrom || ""}
                    onChange={(e) => {
                      setMachineFrom(e.target.value);
                      setErrMachineFrom({ machineFrom: e.target.value });
                    }}
                  >
                    <option value="">Select</option>
                    <option value="indigenous">Indigenous</option>
                    <option value="imported">Imported</option>
                  </select>
                  {(errMachineFrom === null || errMachineFrom === "") && (
                    <p className="invalid-feedback">Indigenous/Imported is required</p>
                  )}
                </div>
                <div className="form-group col-md-5">
                  <label>Machine Type</label>
                  <Select
                    isMulti
                    className={` ${
                      (errProMachineType.length === 0 ||
                        errProMachineType === "") &&
                      "is-invalid"
                    }`}
                    options={proMachineData}
                    value={proMachineType}
                    onChange={(selectedOption) => {
                      setProMachineType(selectedOption);
                      setErrProMachineType(selectedOption);
                    }}
                    placeholder="Select"
                  />
                  {(errProMachineType.length === 0 ||
                    errProMachineType === "") && (
                    <p className="invalid-feedback">
                      Machine Type is required
                    </p>
                  )}
                </div>
                <div className="form-group col-md-1">
                  <button
                    type="button"
                    style={{ border: "1px solid gray", marginTop: "29px" }}
                    className="btn btn-outline-secondary col-xs-offset-1"
                    onClick={() => {
                      handleOpenProModal();
                    }}
                  >
                    <i className="bi bi-plus-lg"></i>
                  </button>
                </div>
              </div>

              <Modal show={isProModalOpen} onHide={handleCloseProModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Machine Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Control
                        className={`form-control`}
                        type="text"
                        onChange={(e) => {
                          setInputProValue(e.target.value);
                        }}
                      />
                    </Form.Group>
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseProModal}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={handleProjectSave}>
                    Save
                  </Button>
                </Modal.Footer>
              </Modal>

              <div className="form-row">
              <div className="form-group col-md-6">
                  <label>Rate of Interest</label>
                  <input
                    type="number"
                    className={`form-control ${
                      (errRateInterest === null ||
                        errRateInterest === "" ||
                        errRateInterest === undefined) &&
                      "is-invalid"
                    }`}
                    value={rateInterest || ""}
                    onChange={(e) => {
                      setRateInterest(e.target.value);
                      setErrRateInterest(e.target.value);
                    }}
                  />
                  {(errRateInterest === null ||
                    errRateInterest === "" ||
                    errRateInterest === undefined) && (
                    <p className="invalid-feedback">
                      Rate of Interest is required
                    </p>
                  )}
                </div>
                <div className="form-group col-md-5">
                  <label>Type of Activity</label>
                  <Select
                    isMulti
                    className={` ${
                      (errActivity.length === 0 ||
                        errActivity === "") &&
                      "is-invalid"
                    }`}
                    options={activityData}
                    value={activity}
                    onChange={(selectedOption) => {
                      setActivity(selectedOption);
                      setErrActivity(selectedOption);
                    }}
                    placeholder="Select"
                  />
                  {(errActivity.length === 0 ||
                    errActivity === "") && (
                    <p className="invalid-feedback">
                      Type of activity is required
                    </p>
                  )}
                </div>
                <Modal show={isActivityModal} onHide={() => setIsActivityModal(false)}>
                <Modal.Header closeButton>
                  <Modal.Title>Type of activity</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form>
                    <Form.Group className="mb-3">
                      <Form.Control
                        className={`form-control`}
                        type="text"
                        placeholder="Type of activity"
                        onChange={(e) => {
                          setInputActivity(e.target.value);
                        }}
                      />
                    </Form.Group>
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setIsActivityModal(false)}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={handleActivity}>
                    Save
                  </Button>
                </Modal.Footer>
              </Modal>
                <div className="form-group col-md-1">
                  <button
                    type="button"
                    style={{ border: "1px solid gray", marginTop: "29px" }}
                    className="btn btn-outline-secondary col-xs-offset-1"
                    onClick={() => {
                      setIsActivityModal(true);
                    }}
                  >
                    <i className="bi bi-plus-lg"></i>
                  </button>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>Date of Commencement</label>
                  <DatePicker
                    className={`form-control ${
                      (errDateCom === null ||
                        errDateCom === "" ||
                        errDateCom === undefined) &&
                      "is-invalid"
                    }`}
                    showYearDropdown
                    showMonthDropdown
                    selected={dateCom || ""}
                    onChange={(date) => {
                      setDateCom(date);
                      setErrDateCom(date);
                    }}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="DD/MM/YYYY"
                  />
                  {(errDateCom === null ||
                    errDateCom === "" ||
                    errDateCom === undefined) && (
                    <p className="invalid-message">
                      Date of Commencement is required
                    </p>
                  )}
                </div>
                <div className="form-group col-md-6">
                  <label>Loan Account No.</label>
                  <input
                    type="text"
                    className={`form-control ${
                      (errLoanAcc === null ||
                        errLoanAcc === "" ||
                        errLoanAcc === undefined) &&
                      "is-invalid"
                    }`}
                    value={loanAcc || ""}
                    onChange={(e) => {
                      setLoanAcc(e.target.value);
                      setErrLoanAcc(e.target.value);
                    }}
                  />
                  {(errLoanAcc === null ||
                    errLoanAcc === "" ||
                    errLoanAcc === undefined) && (
                    <p className="invalid-feedback">
                      Loan Account No. is required
                    </p>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>Loan Sanction</label>
                  <DatePicker
                    className={`form-control ${
                      (errLoanSanction === null ||
                        errLoanSanction === "" ||
                        errLoanSanction === undefined) &&
                      "is-invalid"
                    }`}
                    showYearDropdown
                    showMonthDropdown
                    selected={loanSanction}
                    onChange={(date) => {
                      setLoanSanction(date);
                      setErrLoanSanction(date);
                    }}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="DD/MM/YYYY"
                  />
                  {(errLoanSanction === null ||
                    errLoanSanction === "" ||
                    errLoanSanction === undefined) && (
                    <p className="invalid-message">Loan Sanction is required</p>
                  )}
                </div>
                <div className="form-group col-md-6">
                  <label>Loan Disbursed</label>
                  <DatePicker
                    className={`form-control ${
                      (errLoanSanction === null ||
                        errLoanSanction === "" ||
                        errLoanSanction === undefined) &&
                      "is-invalid"
                    }`}
                    minDate={loanSanction}
                    showYearDropdown
                    showMonthDropdown
                    selected={loanDisbursed}
                    onChange={(date) => {
                      setLoanDisbursed(date);
                      setErrLoanDisbursed(date);
                    }}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="DD/MM/YYYY"
                  />
                  {(errLoanDisbursed === null ||
                    errLoanDisbursed === "" ||
                    errLoanSanction === undefined) && (
                    <p className="invalid-message">
                      Loan Disbursed is required
                    </p>
                  )}
                </div>
              </div>
              <input type="checkbox" onChange={(e) => setApplyCheck(e.target.checked)} /> {!applyCheck && 'Apply Date'}
              {
                applyCheck && (
                <div className="form-row">
                  <div className="form-group col-md-6">

                    <label>Apply Date</label>
                    <DatePicker
                      className={`form-control`}
                      selected={firstRegistration}
                      onChange={(date) => {
                        setFirstRegistration(date);
                      }}
                      minDate={loanDisbursed}
                      showYearDropdown
                      showMonthDropdown
                      dateFormat="dd/MM/yyyy"
                      placeholderText="DD/MM/YYYY"
                    />
                  </div>
                </div>
                )
              }
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>Bank Name</label>
                  <input
                    type="text"
                    className={`form-control ${
                      (errBankName === null || errBankName === "") &&
                      "is-invalid"
                    }`}
                    value={bankName || ""}
                    onChange={(e) => {
                      setBankName(e.target.value);
                      setErrBankName(e.target.value);
                    }}
                  />
                  {(errBankName === null || errBankName === "") && (
                    <p className="invalid-feedback">Bank Name is required</p>
                  )}
                </div>
                <div className="form-group col-md-6">
                  <label>Bank Branch</label>
                  <input
                    type="text"
                    className={`form-control ${
                      (errBankBranch === null || errBankBranch === "") &&
                      "is-invalid"
                    }`}
                    value={bankBranch || ""}
                    onChange={(e) => {
                      setBankBranch(e.target.value);
                      setErrBankBranch(e.target.value);
                    }}
                  />
                  {(errBankBranch === null || errBankBranch === "") && (
                    <p className="invalid-feedback">Bank Branch is required</p>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label>Bank Manager Name </label>
                  <input
                    type="text"
                    className={`form-control ${
                      (errManagerName === null || errManagerName === "") &&
                      "is-invalid"
                    }`}
                    value={managerName || ""}
                    onChange={(e) => {
                      setManagerName(e.target.value);
                      setErrManagerName(e.target.value);
                    }}
                  />
                  {(errManagerName === null || errManagerName === "") && (
                    <p className="invalid-feedback">
                      Bank Manager Name is required
                    </p>
                  )}
                </div>
                <div className="form-group col-md-6">
                  <label>Bank Manager Mobile</label>
                  <input
                    type="number"
                    className={`form-control`}
                    value={managerMobile || ""}
                    onChange={(e) => {
                      setManagerMobile(e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <div className="form-group text-center">
                  <button
                    type="button"
                    style={{ border: "1px solid gray", marginRight: "10px" }}
                    className="btn btn-default btn res-btn-gray"
                    onClick={() => handleBack()}
                  >
                    Previous
                  </button>
                  <button
                    type="button"
                    style={{ border: "1px solid gray" }}
                    className="btn btn-default col-xs-offset-1"
                    onClick={handleNexts}
                  >
                    Next
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  );
};

export default ProjectMaster;
